import gql from 'graphql-tag';

const changePasswordMutation = gql`
  mutation changePassword(
    $oldPassword: String!
    $newPassword: String!
    $confirmPassword: String!
  ) {
    changePassword(
      oldPassword: $oldPassword
      newPassword: $newPassword
      confirmPassword: $confirmPassword
    ) {
      errors {
        key
        value {
          code
          msgId
          valuesJson
        }
      }
      status
    }
  }
`;

export default changePasswordMutation;
